import { ButtonProps, useDisclosure } from '@chakra-ui/react';
import { YoutubePlayer as SharedYoutubePlayer } from '@diamond/shared/ui';
import { useRouteQuery, useRouteRedirection } from '@diamond/sol-buyer/utils';
import { useIsAuthenticated } from '@diamond/sol-buyer-context';

type YoutubePlayerProps = {
  videoUrl: string;
  handleTrackEvent?: () => void;
} & ButtonProps;

export function YoutubePlayer({
  videoUrl,
  handleTrackEvent,
  ...props
}: YoutubePlayerProps) {
  const isAuthenticated = useIsAuthenticated();
  const slug = useRouteQuery()['recipesId'];
  const { withAuth } = useRouteRedirection({ isAuthenticated });
  const { onOpen, onClose, isOpen } = useDisclosure();

  const handleOpen = async () => {
    await withAuth(
      () => {
        onOpen();
        handleTrackEvent?.();
      },
      'recipes',
      slug
    );
  };

  return (
    <SharedYoutubePlayer
      handleOpen={handleOpen}
      handleClose={onClose}
      isOpen={isOpen}
      videoUrl={videoUrl}
      {...props}
    />
  );
}
